/**
 * CSRF Token Management
 * Fetches and caches CSRF tokens for API requests
 */

let cachedToken: string | null = null;

/**
 * Fetch CSRF token from backend
 */
export async function fetchCSRFToken(): Promise<string> {
  // Return cached token if available
  if (cachedToken) {
    return cachedToken;
  }

  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
  const response = await fetch(`${apiBaseUrl}/lite/csrf_token`, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch CSRF token');
  }

  const data = await response.json();
  cachedToken = data.csrf_token;

  if (!cachedToken) {
    throw new Error('CSRF token is null or undefined');
  }

  return cachedToken;
}

/**
 * Clear cached CSRF token (e.g., after logout)
 */
export function clearCSRFToken() {
  cachedToken = null;
}

